function NavigationCard({image, title, onClick}) {
    return (
        <div className='navigation-card' onClick={onClick}>
            <div className='card-img'><img src={image} alt='svg-icon' /></div>
            <div className='card-title'>{title}</div>
        </div>
    );
}

export default NavigationCard;